import {HttpErrorResponse, HttpInterceptorFn, HttpRequest, HttpHandlerFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {throwError, TimeoutError, from, BehaviorSubject} from 'rxjs';
import {mergeMap, timeout, catchError, switchMap, filter, take} from 'rxjs/operators';
import {ApiLoginService, TIMEOUT_MS} from '@kilobytelab/domain';
import {StorageService, UiService} from '@kilobytelab/core';
import {CONFIG} from './app.constants';

let isRefreshing = false;
let refreshTokenSubject = new BehaviorSubject<any>(null);

export const appInterceptor: HttpInterceptorFn = (req, next) => {

  const apiLogin = inject(ApiLoginService);
  const storage = inject(StorageService);
  const uiService = inject(UiService);

  const handle401Error = (request: HttpRequest<any>, nextHandler: HttpHandlerFn) => {
    if (!isRefreshing) {
      isRefreshing = true;
      refreshTokenSubject.next(null);
      return apiLogin.refreshToken().pipe(
        switchMap(() => {
          isRefreshing = false;
          refreshTokenSubject.next(true);
          return nextHandler(request)
        }),
        catchError((err) => {
          isRefreshing = false;
          refreshTokenSubject.next(null);
          apiLogin.logout().catch(console.error)
          return throwError(() => err)
        })
      )
    } else {
      return refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(() => nextHandler(request))
      )
    }
  };

  return storage.getAppObs().pipe(
    mergeMap(appData => {
      const bbdd = appData ? appData.BBDD : 'USERS';
      const request = req.clone({
        withCredentials: true,
        setHeaders: {
          'x-app': CONFIG.NOMBREAPP,
          'x-version': CONFIG.VERSION,
          'x-issuer': bbdd
        }
      });
      return next(request).pipe(
        timeout(TIMEOUT_MS),
        catchError((error: any) => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            if (
              request.url.includes('login') ||
              request.url.includes('version') ||
              request.url.includes('refresh')
            ) return throwError(() => error);
            return handle401Error(request, next)
          }
          if (error instanceof TimeoutError) {
            return from(uiService.mostrarToast('La petición excedió el tiempo límite', true)).pipe(
              switchMap(() => throwError(() => new Error('Tiempo de espera agotado')))
            )
          }
          return throwError(() => error)
        })
      )
    })
  )
}

